import HeroSection from '@global/Blocks/Hero'
import Button from '@global/Button'
import Field from '@global/FormInput/Field'
import { resetPassword } from '@lib/api-services/authService'
import { Formik } from 'formik'
import { useState } from 'react'
import * as yup from 'yup'
import * as S from './Login.styled'

import { Container } from '@styles/global.styled'
import nProgress from 'nprogress'
import InstructionSent from './InstructionSent'

// const Loader = dynamic(() => import('@global/loader/Loader'), {
//   ssr: false
// })

const LoginEmailPasswordResetForm = ({ title, text, form, register }) => {
  const [resetSubmitted, setResetSubmitted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [emailReset, setEmailReset] = useState('')

  // form validation schema
  const schema = yup.object().shape({
    email: yup
      .string()
      .email('Enter a valid email')
      .required('Email is required'),
  })

  const handleSubmit = async (values) => {
    nProgress.start()
    setIsLoading(true)
    await resetPassword(values.email)
    setResetSubmitted(true)
    setIsLoading(false)
    nProgress.done()
    setEmailReset(values.email)
  }

  return (
    <>
      <HeroSection
        title={'YOUR ACCOUNT'}
        bgImageUrl={'/imgs/background-login.jpg'}
      />

      <Container>
        {resetSubmitted ? (
          <InstructionSent emailResend={emailReset} />
        ) : (
          <S.FormContainer>
            <S.ContainerLeft>
              <S.Title>{title}</S.Title>
              <S.Description dangerouslySetInnerHTML={{ __html: text }} />
            </S.ContainerLeft>

            <S.ContainerRight>
              <Formik
                initialValues={{
                  email: '',
                }}
                validationSchema={schema}
                onSubmit={handleSubmit}
              >
                {({ errors, touched, handleSubmit, getFieldProps }) => (
                  <form onSubmit={handleSubmit} noValidate>
                    <S.Form>
                      <Field
                        type={form.yourDetails.fields[0].type}
                        label={form.yourDetails.fields[0].label}
                        required={form.yourDetails.fields[0].required}
                        placeholder={form.yourDetails.fields[0].placeholder}
                        {...getFieldProps(form.yourDetails.fields[0].name)}
                        error={touched.email && errors.email}
                      />
                      <Button
                        type={form.submit.type}
                        color='primary'
                        disabled={isLoading}
                      >
                        {form.submit.label}
                      </Button>
                      <S.SubActionContainer>
                        <S.TextLink>Back to</S.TextLink>{' '}
                        <S.CustomLink href={`/login/`} size='small'>
                          Login
                        </S.CustomLink>
                      </S.SubActionContainer>
                    </S.Form>
                  </form>
                )}
              </Formik>
            </S.ContainerRight>
          </S.FormContainer>
        )}
      </Container>
    </>
  )
}

LoginEmailPasswordResetForm.defaultProps = {
  title: 'Forgot your Password',
  text: `Please enter the email address you used when you joined and we'll send you instructions to reset your password.
    <br /><br />
    For security reasons, we do NOT store passwords. We will never send you your password via email.`,
  copySmall: '',
  closeBtnLabel: '',
  searchBtnLabel: '',
  register: {
    label: 'Register',
    link: '/create-account/',
  },
  form: {
    yourDetails: {
      title: '',
      fields: [
        {
          type: 'email',
          label: 'Email Address',
          required: true,
          fieldSize: 'u-1/2@tablet u-1/2@desktop u-push-1/4@tablet',
          name: 'email',
          placeholder: 'Your email address',
        },
      ],
    },
    submit: {
      type: 'submit',
      label: 'Send reset instructions',
      fieldSize: 'u-1/3@palm u-text-center',
    },
  },
}

export default LoginEmailPasswordResetForm
